import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Pane } from '@sheridan-prize/ui';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { Toaster } from 'sonner';
import {
  MaterialSymbol,
  LoadingIndicator,
} from '@moonjellydigital/react-components';

export const Route = createRootRoute({
  component: () => (
    <>
      <div className="appshell">
        <a className="skip-link" href="#title">
          Skip to Main Content
        </a>
        <Toaster
          position="top-center"
          icons={{
            success: (
              <MaterialSymbol
                icon="check_circle"
                style={{ color: 'var(--color-success)' }}
              />
            ),
            info: (
              <MaterialSymbol
                icon="info"
                style={{ color: 'var(--color-info)' }}
              />
            ),
            warning: (
              <MaterialSymbol
                icon="warning"
                style={{ color: 'var(--color-warning)' }}
              />
            ),
            error: (
              <MaterialSymbol
                icon="error"
                style={{ color: 'var(--color-error)' }}
              />
            ),
            loading: <LoadingIndicator />,
          }}
          toastOptions={{
            classNames: {
              toast: 'sp-toast',
              title: 'sp-toast__title',
              description: 'sp-toast__description',
            },
          }}
        />
        <SiteHeader />
        <Outlet />
        <SiteFooter />
      </div>
      <TanStackRouterDevtools />
    </>
  ),
  notFoundComponent: () => (
    <Pane classes={'sp-main sp-notFound'} tag="main">
      <h1>Page Not Found</h1>
      <p>{"404. There's nothing here."}</p>
    </Pane>
  ),
});
